/*@ngInject*/
const FieldTemplateComponentRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getFieldTemplateComponentSettings = function (fieldType, uiFormTemplateId) {
        var url = '/rest/fieldTemplateComponent/settings',
            config = {
                params: {
                    fieldType: fieldType,
                    uiFormTemplateId: uiFormTemplateId
                }
            };

        return this.get(url, config);
    };

    this.getFieldTemplateComponentTypes = function () {
        var url = '/rest/fieldTemplateComponent/types';

        return this.get(url);
    };
};

angular.module('ums.configuration')
    .service('fieldTemplateComponentRepository', FieldTemplateComponentRepository);
